<script>
  import { Route, useNavigate } from "svelte-navigator";
  import { useUrlParams } from "@stores/urlStore.js";
  import { ANALYSIS_SUBROUTES, ROUTES } from "@utils/routes.js";
  import WorkflowExplorer from "./analysis/workflowExplorer.svelte";
  import ModelExport from "./analysis/modelExport.svelte";
  import Ngrams from "./analysis/ngrams.svelte";
  import LicenceChecker from "./analysis/LicenceChecker.svelte";
  import Heatmap from "./analysis/heatmap.svelte";
  import AppConnections from "./analysis/appConnections.svelte";
  import Shortcuts from "./analysis/shortcuts.svelte";
  import Workload from "./analysis/workload.svelte";
  import DashboardUsageAndWorkflow from "./analysis/dashboard.svelte";
  import Treemap from "./analysis/treemap.svelte";
  import { SvelteFlowProvider } from "@xyflow/svelte";
  import CaseExplorer from "./analysis/CaseExplorer.svelte";
  import DottetChart from "./analysis/components/DottetChart.svelte";
  import KpiMatrix from "./analysis/KPIMatrix.svelte";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";

  const urlParams = useUrlParams();
  const navigate = useNavigate();
  const { getFiltersConfig } = filtersConfigStore;
  let redirected = false;

  $: ({ analysisid } = $urlParams);
  $: hasRequiredParams = Boolean($urlParams.analysisid);
  $: if (!hasRequiredParams && !redirected) {
    redirected = true;
    Promise.resolve(navigate(ROUTES.dam.root, { replace: true })).catch(() => {
      window.location.replace(ROUTES.dam.root);
    });
  }
  $: if (analysisid) {
    getFiltersConfig(analysisid);
  }

  $$restProps;
</script>
{#if hasRequiredParams}
    <Route path={ANALYSIS_SUBROUTES.dashboard}
      ><DashboardUsageAndWorkflow {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.treemap}><Treemap {analysisid} /></Route>
    <Route path={ANALYSIS_SUBROUTES.automation}>
      <SvelteFlowProvider><Ngrams {analysisid} /></SvelteFlowProvider>
    </Route>
    <Route path={ANALYSIS_SUBROUTES.licenseChecker}
      ><LicenceChecker {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.workflow}>
      <SvelteFlowProvider><WorkflowExplorer {analysisid} /></SvelteFlowProvider>
    </Route>
    <Route path={ANALYSIS_SUBROUTES.bpmnexport}
      ><ModelExport {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.heatmap}><Heatmap {analysisid} /></Route>
    <Route path={ANALYSIS_SUBROUTES.connections}
      ><AppConnections {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.shortcuts}><Shortcuts {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.copyPaste}
      ><Shortcuts {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.workload}><Workload {analysisid} /></Route>
    <Route path={ANALYSIS_SUBROUTES.caseExplorer}
      ><CaseExplorer {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.dottetChart}
      ><DottetChart {analysisid} /></Route
    >
    <Route path={ANALYSIS_SUBROUTES.kpiMatrix}><KpiMatrix {analysisid} /></Route
    >
{/if}
